// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__307IE","colBig":"styles_colBig__2co-m","colSmall":"styles_colSmall__eA5Lx"};